import type { JSX } from 'react';

export interface TypographyProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  variant?: TypographyVariant;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

export enum TypographyVariant {
  TITLE,
  MODAL_TITLE,
  LARGE_SUBTITLE,
  MEDIUM_SUBTITLE,
  BODY_TEXT,
  BODY_STRONG,
  MEDIUM_BODY_TEXT,
  SMALL_BODY_TEXT,
}
